// extracted by mini-css-extract-plugin
export default {"description":"zp8uy2","alignFontSize":"veCD9x"};